export const generateMultilineFromString = (str: string) => {
  return str.split("\n").map((line, index) => <div key={index}>{line}</div>);
};
